// src/stone/icons/DollarPhone2X.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var DollarPhone2X = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 40 40",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M10 2.667A2.333 2.333 0 0 0 7.667 5v30A2.333 2.333 0 0 0 10 37.333h20A2.333 2.333 0 0 0 32.333 35V5A2.333 2.333 0 0 0 30 2.667zm-3.064-.731A4.33 4.33 0 0 1 10 .666h20A4.333 4.333 0 0 1 34.333 5v30A4.333 4.333 0 0 1 30 39.333H10A4.333 4.333 0 0 1 5.667 35V5c0-1.15.456-2.251 1.269-3.064" }),
      /* @__PURE__ */ jsx("path", { d: "M21 7.333v25.334h-2V7.333z" }),
      /* @__PURE__ */ jsx("path", { d: "M18.935 9.82c2.628-.188 5.628.487 7.172 1.335l.876.482-.963 1.753-.877-.482c-1.158-.636-3.763-1.258-6.065-1.093-1.143.082-2.086.35-2.717.795-.577.407-.948.993-.948 1.943 0 1.164.482 1.895 1.28 2.48.866.635 2.063 1.065 3.44 1.524l.284.095c1.23.407 2.594.86 3.656 1.544 1.215.783 2.147 1.943 2.147 3.722 0 1.588-.526 2.852-1.486 3.76-.934.883-2.183 1.34-3.485 1.535-2.588.39-5.737-.2-8.254-1.105l-.941-.339.676-1.882.942.339c2.346.843 5.14 1.33 7.28 1.01 1.062-.16 1.872-.505 2.407-1.011.51-.481.861-1.193.861-2.307 0-.922-.42-1.518-1.23-2.04-.84-.541-1.971-.918-3.287-1.356l-.203-.067c-1.325-.442-2.829-.958-3.99-1.808-1.228-.901-2.097-2.196-2.097-4.094 0-1.607.693-2.8 1.796-3.578 1.05-.74 2.403-1.06 3.726-1.155" })
    ]
  }
);
var DollarPhone2X_default = DollarPhone2X;

export {
  DollarPhone2X_default
};
